/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_TitleInputs */

const en_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Plans`)
};

const de_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pläne vergleichen`)
};

const fr_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer les plans`)
};

const es_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar planes`)
};

const it_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta i piani`)
};

const nl_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plannen vergelijken`)
};

const pl_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównaj plany`)
};

const fi_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaa suunnitelmia`)
};

const da_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign planer`)
};

const sv_pricing_compare_title = /** @type {(inputs: Pricing_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför planer`)
};

/**
* | output |
* | --- |
* | "Compare Plans" |
*
* @param {Pricing_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_title = /** @type {((inputs?: Pricing_Compare_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_title(inputs)
	if (locale === "fr") return fr_pricing_compare_title(inputs)
	if (locale === "es") return es_pricing_compare_title(inputs)
	if (locale === "it") return it_pricing_compare_title(inputs)
	if (locale === "nl") return nl_pricing_compare_title(inputs)
	if (locale === "pl") return pl_pricing_compare_title(inputs)
	if (locale === "fi") return fi_pricing_compare_title(inputs)
	if (locale === "da") return da_pricing_compare_title(inputs)
	if (locale === "sv") return sv_pricing_compare_title(inputs)
	return en_pricing_compare_title(inputs)
});